import { formatMoney, unformat } from 'accounting';

const CENTS_IN_DOLLAR = 100;

export const formatCents = (cents, precision = 2) => {
  const usd = cents / CENTS_IN_DOLLAR;

  return formatMoney(usd, '$', precision, ',', '.');
};

// 215 to 2.15
export const centsAsDecimal = (price) => (price / CENTS_IN_DOLLAR).toString();

// 10800 to 108.00
export const centsAsDecimalFixed = (price) => (price / CENTS_IN_DOLLAR).toFixed(2);

// 2.10 to 210
export const decimalAsCents = (price) => price * CENTS_IN_DOLLAR;

// $2.10 to 2.10
export const currencyAsDecimal = (price) => unformat(price);

// $2.10 to 210
export const currencyAsCents = (price) => {
  const decimal = currencyAsDecimal(price);
  return decimalAsCents(decimal);
};

export const priceWithDiscount = (price, discountPercent) => price * (1 - discountPercent / 100);
